export default "__VITE_ASSET__CivNoQsq__"